import { areIntervalsOverlapping, format, parse } from "date-fns";
import { createCachedSelector } from "re-reselect";
import { createSelector } from "starfx";

import { schemaB, TSChemaBlue } from "@app/stateCommon/schemaBlue";
import { TBlueAny, TBlueCommon, TBlueTable } from "@app/types/insider";

import { isTBlueObj, isTBlueTable } from "../routines/mapperfn";
import { schema } from "../schema";
import { shardBuilder } from "../workers/helpers";
import { AppState } from "../xstore";

function createParameterSelector(selector: any) {
  return (_: AppState, params: any) => selector(params);
}

const getIntervalAsDate = createParameterSelector(
  (params: { start: Date; end: Date }) => ({
    start: params.start,
    end: params.end,
  })
);

const getIntervalAsFormatedString = createParameterSelector(
  (params: { start: string; end: string }) => ({
    start: params.start,
    end: params.end,
  })
);

const getObjectName = createParameterSelector(
  (params: { objectName: string }) => params.objectName
);
const getShid1 = createParameterSelector(
  (params: { shid1: string }) => params.shid1
);

export const selectShardsOfInterval = createCachedSelector(
  schema.app.select,
  getIntervalAsDate,
  (app, interval) => {
    const absolutestart = new Date(app?.absolutestart);
    const shards = shardBuilder(absolutestart);
    const instersection = shards.filter((shard) =>
      areIntervalsOverlapping(
        {
          start: new Date(parse(shard.start, "yyyy-MM-dd", new Date())),
          end: new Date(parse(shard.end, "yyyy-MM-dd", new Date())),
        },
        {
          start: interval.start,
          end: interval.end,
        }
      )
    );

    return instersection.map((shard) => ({
      start: format(new Date(shard.start), "yyyy-MM-dd"),
      end: format(new Date(shard.end), "yyyy-MM-dd"),
    }));
  }
)((_, params) => JSON.stringify(params));

export const selCountOfShard = createSelector(
  getObjectName,
  getShid1,
  (
    objectName,
    shid1
  ): {
    storeHKey: string;
    storeHValue: string;
    storeShardCount: number;
  } => {
    const s = window.fx.getState();
    const objectDef = schemaB[objectName];
    if (isTBlueTable(objectDef)) {
      const ds = s[objectName] as TBlueTable<any>;
      //we filter out our shard
      const currentShard = Object.values(ds).filter(
        (row) => row.shid1 === shid1
      );

      //we need the _hkey and _hvalue of the shard for later compare with what we have in the cache
      const kv = Object.keys(currentShard?.[0] || {}).filter((x) =>
        x.includes("::ttl=")
      );
      //that is our _hkey:
      const k = kv?.[0] || "";
      //the value of this shard's _hkey (as we got it at the last query saved  in starfx)
      const v = (currentShard?.[0] || {})[k] || "";

      const o = {
        storeHKey: k,
        storeHValue: v,
        storeShardCount: currentShard.length,
      };
      return o;
    }
    return {
      storeHKey: "",
      storeHValue: "",
      storeShardCount: 0,
    };
  }
);
